// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles-module__tooltip___2ORcN"};